import { Abstrap } from '../../..';

const { propTypes } = Abstrap;

const defaultProps = { ...Abstrap.defaultProps, componentClass: 'div' };

class NotificationItemIcon extends Abstrap {

    getClassNameSchema() {
        const {
            className,
        } = this.props;
        return [
            'c-notification__icon',
            className,
        ];
    }

}

NotificationItemIcon.propTypes = propTypes;

NotificationItemIcon.defaultProps = defaultProps;

export default NotificationItemIcon;
